import { mergeConfig } from 'Components/Worksheets/Core/Helpers/configHelpers';
import bsMddSharedConfig from 'Components/Worksheets/MaximumDryDensityWorksheet/Bs/Shared/Config';
import { default as qestIds } from 'Components/Worksheets/QestIds';
import getLabelConfig from './labelConfig';

const getConfig = (prefix: string) =>
  mergeConfig(
    bsMddSharedConfig(prefix),
    {
      [`${prefix}.Preparation.MouldType`]: { visible: false },
      [`${prefix}.TestPortions.HeightColTopSoil1`]: { uom: 'mm', format: { nearest: 0.5 } },
      [`${prefix}.TestPortions.HeightColTopSoil2`]: { uom: 'mm', format: { nearest: 0.5 } },
      [`${prefix}.TestPortions.HeightColTopSoil3`]: { uom: 'mm', format: { nearest: 0.5 } },
      [`${prefix}.TestPortions.HeightColTopSoil4`]: { uom: 'mm', format: { nearest: 0.5 } },
      [`${prefix}.TestPortions.MeanSoilHeight`]: { uom: 'mm', format: { nearest: 0.5 } },
      [`${prefix}.TestPortions.SampleHeight`]: { uom: 'mm', format: { nearest: 0.5 } },
    },
    getLabelConfig(`${prefix}`)
  );

export default {
  [qestIds.maximumDryDensity.BS_1377_2_Clause_11_7.rev2022]: getConfig,
};
